
/*
 * VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { NgControl } from "@angular/forms";
import { Directive, Input } from "@angular/core";

@Directive({
  selector: "[vpDisableControl]"
})
export class VNCDisableControlDirective {

  @Input() set vpDisableControl( condition: boolean ) {
    const action = condition ? "disable" : "enable";
    if (this.ngControl.control) {
      this.ngControl.control[action]();
    }
  }

  constructor( private ngControl: NgControl ) {
  }

}
